import React from "react"
import SkeletonElement from "./SkeletonElement"

const DailyDetailSkeleton: React.FC = () => {
  return <SkeletonElement type="widget daily-item" />
}

export default DailyDetailSkeleton
